import { GetCountryNetworkResponse } from '@1po/1po-bff-fe-spec/generated/backoffice/country_network/response/GetCountryNetworkResponse';
import {
  BACKOFFICE_GET_COUNTRY_NETWORK_RESPONSE,
  BACKOFFICE_UPDATE_COUNTRY_RETURN_FEATURE_RESPONSE,
} from '@1po/1po-bff-fe-spec/generated/common/ResponseType';
import { all, call, put, takeEvery } from '@redux-saga/core/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { SagaIterator } from 'redux-saga';
import { WsResponse } from 'domains/webSockets/WebSocket.types';
import { notifyTop } from 'UI';
import { FOUND, LOADING, sagaGuard } from 'utils';
import { sendGetCountryNetwork, sendUpdateMktpReturnFeature, sendUpdateRdReturnFeature } from './CountryNetwork.api';
import {
  getCountryNetworkRequestSaga as getCountryNetworkRequestAction,
  setCountryNetwork,
  setCountryNetworkStatus,
} from './CountryNetwork.store';
import {
  GET_COUNTRY_NETWORK_REQUEST,
  UPDATE_MKTP_RETURN_FEATURE_REQUEST,
  UPDATE_RD_RETURN_FEATURE_REQUEST,
} from './CountryNetwork.types';

export function* fetchCountryNetworkRequestSaga(): SagaIterator {
  yield put(setCountryNetworkStatus(LOADING));
  yield put(sendGetCountryNetwork());
}

export function* fetchCountryNetworkResponseSaga(action: WsResponse<GetCountryNetworkResponse>): SagaIterator {
  const data = action.payload;
  yield put(setCountryNetwork(data));
  yield put(setCountryNetworkStatus(FOUND));
}

export function* updateRdReturnFeatureRequestSaga(action: PayloadAction<{ isEnabled: boolean }>): SagaIterator {
  yield put(sendUpdateRdReturnFeature(action.payload.isEnabled));
}

export function* updateMktpReturnFeatureRequestSaga(action: PayloadAction<{ isEnabled: boolean }>): SagaIterator {
  yield put(sendUpdateMktpReturnFeature(action.payload.isEnabled));
}

export function* updateCountryReturnFeatureResponseSaga(action: WsResponse<{ result: string }>): SagaIterator {
  if (action.payload.result === 'SUCCESS' || action.payload.result === 'NO_CHANGE') {
    yield call(notifyTop, 'success', 'Return feature settings updated successfully');
    yield put(getCountryNetworkRequestAction());
  } else {
    yield call(notifyTop, 'error', 'Failed to update return feature settings');
  }
}

export function* CountryNetworkSagas(): SagaIterator {
  yield all([
    takeEvery(GET_COUNTRY_NETWORK_REQUEST, sagaGuard(fetchCountryNetworkRequestSaga)),
    takeEvery(BACKOFFICE_GET_COUNTRY_NETWORK_RESPONSE, sagaGuard(fetchCountryNetworkResponseSaga)),
    takeEvery(UPDATE_RD_RETURN_FEATURE_REQUEST, sagaGuard(updateRdReturnFeatureRequestSaga)),
    takeEvery(UPDATE_MKTP_RETURN_FEATURE_REQUEST, sagaGuard(updateMktpReturnFeatureRequestSaga)),
    takeEvery(BACKOFFICE_UPDATE_COUNTRY_RETURN_FEATURE_RESPONSE, sagaGuard(updateCountryReturnFeatureResponseSaga)),
  ]);
}
